
  <div class="splash-screen" *ngIf="show" @fadeOut>
       <div fxLayout="column" fxLayoutAlign="center center">
           <img src="../../../assets/prism.png" style="width: auto; height: 30vh;bottom: 40vh; position: absolute;">
           <img src="../../../assets/ethele-white.png" style="width: auto; height: 5vh;bottom: 15vh; position: absolute;">
       </div>
  </div>
